export const MANAGE_OUTS_FETCH_ORDERS_BEGIN = 'MANAGE_OUTS_FETCH_ORDERS_BEGIN';
export const MANAGE_OUTS_FETCH_ORDERS_SUCCESS = 'MANAGE_OUTS_FETCH_ORDERS_SUCCESS';
export const MANAGE_OUTS_FETCH_ORDERS_FAILURE = 'MANAGE_OUTS_FETCH_ORDERS_FAILURE';
export const MANAGE_OUTS_FETCH_ORDERS_DISMISS_ERROR = 'MANAGE_OUTS_FETCH_ORDERS_DISMISS_ERROR';

export const MANAGE_OUTS_FETCH_AUDIT_LOG_BEGIN = 'MANAGE_OUTS_FETCH_AUDIT_LOG_BEGIN';
export const MANAGE_OUTS_FETCH_AUDIT_LOG_SUCCESS = 'MANAGE_OUTS_FETCH_AUDIT_LOG_SUCCESS';
export const MANAGE_OUTS_FETCH_AUDIT_LOG_FAILURE = 'MANAGE_OUTS_FETCH_AUDIT_LOG_FAILURE';
export const MANAGE_OUTS_FETCH_AUDIT_LOG_DISMISS_ERROR = 'MANAGE_OUTS_FETCH_AUDIT_LOG_DISMISS_ERROR';

export const MANAGE_OUTS_RESET_DATA = 'MANAGE_OUTS_RESET_DATA';

export const MANAGE_OUTS_ERROR_CONTACT_ADMIN = 'Please contact admin';

export const MANAGE_OUTS_FETCH_STATE_COMPARE_BEGIN = 'MANAGE_OUTS_FETCH_STATE_COMPARE_BEGIN';
export const MANAGE_OUTS_FETCH_STATE_COMPARE_SUCCESS = 'MANAGE_OUTS_FETCH_STATE_COMPARE_SUCCESS';
export const MANAGE_OUTS_FETCH_STATE_COMPARE_FAILURE = 'MANAGE_OUTS_FETCH_STATE_COMPARE_FAILURE';
export const MANAGE_OUTS_FETCH_STATE_COMPARE_DISMISS_ERROR = 'MANAGE_OUTS_FETCH_STATE_COMPARE_DISMISS_ERROR';

export const MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_BEGIN = 'MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_BEGIN';
export const MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_SUCCESS = 'MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_SUCCESS';
export const MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_FAILURE = 'MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_FAILURE';
export const MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_DISMISS_ERROR = 'MANAGE_OUTS_EXPORT_HISTORY_SEARCH_FILE_DISMISS_ERROR';

export const MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_BEGIN = 'MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_BEGIN';
export const MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_SUCCESS = 'MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_SUCCESS';
export const MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_FAILURE = 'MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_FAILURE';
export const MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_DISMISS_ERROR = 'MANAGE_OUTS_EXPORT_HISTORY_TRACK_FILE_DISMISS_ERROR';

